import React from 'react';
import { cn } from '@/lib/utils';
import { useTheme } from '@/contexts/ThemeContext';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '4xl' | '6xl' | 'full';
}

/**
 * Single Responsibility: Container layout with consistent spacing and theming
 * Open/Closed: Extensible through className and maxWidth props
 */
export const PageContainer: React.FC<PageContainerProps> = ({
  children,
  className,
  maxWidth = '6xl',
}) => {
  const { theme } = useTheme();

  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '4xl': 'max-w-4xl',
    '6xl': 'max-w-6xl',
    full: 'max-w-full',
  };

  return (
    <div
      className={cn(
        'h-full w-full',
        theme === 'dark' ? 'bg-slate-900' : 'bg-slate-50/30',
        className
      )}
    >
      <div className={cn('mx-auto space-y-6 p-6', maxWidthClasses[maxWidth])}>{children}</div>
    </div>
  );
};
